import { render, staticRenderFns } from "./PlantTitle.vue?vue&type=template&id=9d4cc600&scoped=true&"
import script from "./PlantTitle.vue?vue&type=script&lang=js&"
export * from "./PlantTitle.vue?vue&type=script&lang=js&"
import style0 from "./PlantTitle.vue?vue&type=style&index=0&id=9d4cc600&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4cc600",
  null
  
)

export default component.exports